/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetBreakdownReportQueryResponse, GetBreakdownReportPathParams, GetBreakdownReport400, GetBreakdownReport401, GetBreakdownReport403, GetBreakdownReport404, GetBreakdownReport409, GetBreakdownReport500 } from "../../types/equipmentController/GetBreakdownReport.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getBreakdownReport } from "../../client/equipmentController/getBreakdownReport.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getBreakdownReportQueryKey = (organizationId: GetBreakdownReportPathParams["organizationId"] | undefined, reportId: GetBreakdownReportPathParams["reportId"] | undefined) => [{ url: '/api/organizations/:organizationId/equipment/breakdown-reports/:reportId', params: {organizationId:organizationId,reportId:reportId} }] as const

export type GetBreakdownReportQueryKey = ReturnType<typeof getBreakdownReportQueryKey>

export function getBreakdownReportQueryOptions(organizationId: GetBreakdownReportPathParams["organizationId"] | undefined, reportId: GetBreakdownReportPathParams["reportId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getBreakdownReportQueryKey(organizationId, reportId)
        return queryOptions<GetBreakdownReportQueryResponse, ResponseErrorConfig<GetBreakdownReport400 | GetBreakdownReport401 | GetBreakdownReport403 | GetBreakdownReport404 | GetBreakdownReport409 | GetBreakdownReport500>, GetBreakdownReportQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && reportId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getBreakdownReport(organizationId!, reportId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get breakdown report detail
 * {@link /api/organizations/:organizationId/equipment/breakdown-reports/:reportId}
 */
export function useGetBreakdownReport<TData = GetBreakdownReportQueryResponse, TQueryData = GetBreakdownReportQueryResponse, TQueryKey extends QueryKey = GetBreakdownReportQueryKey>(organizationId: GetBreakdownReportPathParams["organizationId"] | undefined, reportId: GetBreakdownReportPathParams["reportId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetBreakdownReportQueryResponse, ResponseErrorConfig<GetBreakdownReport400 | GetBreakdownReport401 | GetBreakdownReport403 | GetBreakdownReport404 | GetBreakdownReport409 | GetBreakdownReport500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getBreakdownReportQueryKey(organizationId, reportId)
         

         const query = useQuery({
          ...getBreakdownReportQueryOptions(organizationId, reportId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetBreakdownReport400 | GetBreakdownReport401 | GetBreakdownReport403 | GetBreakdownReport404 | GetBreakdownReport409 | GetBreakdownReport500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}